import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import { authGuard } from '@/auth/authGuard'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
        },
        {
            path: '/login-error',
            name: 'login-error',
            component: () => import(/* webpackChunkName: "login-error" */ '@/views/LoginError.vue')
        },
        {
            path: '/user-profile',
            name: 'user-profile',
            beforeEnter: authGuard,
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/UserProfile.vue')
        },
        {
            path: '/data-verification',
            name: 'data-verification',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/DataVerification.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: [ 'Verification' ]
            }
        },
        {
            path: '/order-certificate',
            name: 'order-certificate',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/OrderCertificate.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/order-birth-certificate',
            name: 'order-birth-certificate',
            component: () => import('@/views/OrderBirthCertificate.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/order-death-certificate',
            name: 'order-death-certificate',
            component: () => import('@/views/OrderDeathCertificate.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/order-marriage-certificate',
            name: 'order-marriage-certificate',
            component: () => import('@/views/OrderMarriageCertificate.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/order-divorce-certificate',
            name: 'order-divorce-certificate',
            component: () => import('@/views/OrderDivorceCertificate.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/user-administration',
            name: 'user-administration',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/UserAdministration.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Administrator']
            }
        },
        {
            path: '/birth-verification',
            name: 'birth-verification',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/BirthVerification.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Birth Verification', 'Administrator'] /*birth*/
            }
        },
        {
            path: '/death-verification',
            name: 'death-verification',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/DeathVerification.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Death Verification', 'Death Insurance Verification', 'Administrator'] /*death*/
            }
        },
        {
            path: '/marriage-verification',
            name: 'marriage-verification',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/MarriageVerification.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Marriage Verification', 'Administrator'] /*marriage*/
            }
        },
        {
            path: '/divorce-verification',
            name: 'divorce-verification',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/DivorceVerification.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Divorce Verification', 'Administrator'] /*divorce*/
            }
        },
        {
            path: '/mothers-worksheet',
            name: 'mothers-worksheet',
            component: () => import('@/views/MothersWorksheet.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/marriage-worksheet',
            name: 'marriage-worksheet',
            component: () => import('@/views/MarriageWorksheet.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/inbox',
            name: 'inbox',
            component: () => import('@/views/Inbox.vue'),
            beforeEnter: authGuard
            // meta: {
            //     requireRoles: ['Public']
            // }
        },
        {
            path: '/inbox-details/:id/:type',
            name: 'inbox-details',
            component: () => import('@/views/InboxDetails.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Divorce Verification', 'Marriage Verification', 'Death Verification', 'Birth Verification', 'Death Insurance Verification', 'Administrator']
            }
        },
        {
            path: '/inbox-cert-details/:id',
            name: 'inbox-cert-details',
            component: () => import('@/views/InboxCertDetails.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/user-setup',
            name: 'user-setup',
            component: () => import('@/views/UserSetup.vue')
        },
        {
            path: '/access-requests',
            name: 'access-requests',
            component: () => import('@/views/AccessRequests.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Administrator']
            }
        },
        {
            path: '/payment-processing/:paymentId',
            name: 'payment-processing',
            component: () => import('@/views/PaymentProcessing.vue'),
            beforeEnter: authGuard,
            meta: {
                requireRoles: ['Public']
            }
        },
        {
            path: '/help',
            name: 'help',
            component: () => import('@/views/Help.vue'),
            beforeEnter: authGuard
        }
    ]
})
